
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","height":"100","viewBox":"0 0 150 150"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M29.075 46.536L7.937 30.198a13.971 13.971 0 0021.138 16.338zm8.864 13.651a13.982 13.982 0 00-9.883-4.077H14.028A14.041 14.041 0 000 70.139v7.014a7.014 7.014 0 007.014 7.014h14.447a32.138 32.138 0 0116.478-23.979zm81.3-11.091a14.028 14.028 0 10-14.028-14.028 14.028 14.028 0 0014.028 14.025zm-9.522 28.738A25.04 25.04 0 0091.2 63.526l-12.073-9.333A24.44 24.44 0 1045.9 28.51L9.964.739a3.507 3.507 0 00-4.923.616L.739 6.893a3.507 3.507 0 00.616 4.921l128.96 99.67a3.507 3.507 0 004.925-.616l4.3-5.539a3.507 3.507 0 00-.616-4.921zM28.056 88.377v6.31a10.521 10.521 0 0010.521 10.521H101.7a10.4 10.4 0 002.755-.41L50.852 63.372a25.169 25.169 0 00-22.796 25.005zm98.2-32.267h-14.031a13.982 13.982 0 00-9.883 4.077 32.065 32.065 0 0116.458 23.98h14.466a7.014 7.014 0 007.014-7.014v-7.014a14.041 14.041 0 00-14.027-14.028z","fill":"#63cdf5"}})])
          )
        }
      }
    